import React from 'react';

import { CaseChallengeItemModel, CaseChallengesTabContent } from '../case-challenges-tab-content';

export const Case1ChallengesTabContent = React.memo(() => {
  const Case1Challenges = React.useMemo<CaseChallengeItemModel[]>(() => {
    const case1Challenges: CaseChallengeItemModel[] = [
      {
        type: 'default',
        icon: 'clock',
        text: 'High MTTR to resolve network issues',
      },
      {
        type: 'default',
        icon: 'reload',
        text: 'Manual optimization recommendations process',
      },
      {
        type: 'default',
        icon: 'avatarLarger',
        text: 'Negative impact on customer experience due to lengthy resolution times',
      },
    ];

    return case1Challenges;
  }, []);

  return <CaseChallengesTabContent items={Case1Challenges} />;
});
